import { render } from "./LovsManagementTestDialog.vue?vue&type=template&id=bc0e804c&ts=true"
import script from "./LovsManagementTestDialog.vue?vue&type=script&lang=ts"
export * from "./LovsManagementTestDialog.vue?vue&type=script&lang=ts"

import "./LovsManagementTestDialog.vue?vue&type=style&index=0&id=bc0e804c&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__